import React, { useEffect } from 'react';
import { Datagrid, TextField, Loading, useUnselectAll } from 'react-admin';
import EditButtonWithOnClick from '../../../core/components/EditButtonWithOnClick';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  editButton: {
    color: '#757575',
    minWidth: '24px',
    padding: '6px 0',
    '& span': {
      paddingRight: 0
    }
  },
  editButtonColumnStyle: {
    width: '24px'
  }
});

const UserPhoneDatagrid = props => {
  const {
    handlePhoneEditButtonClick,
    classes,
    hasEditPermission,
    ...dataGridProps
  } = props;

  //unselecting all the checkboxes from the deleting actions in the ComponenWillUnmount listener
  const unSelectAll = useUnselectAll(dataGridProps.resource);
  useEffect(() => () => unSelectAll(), [unSelectAll]);

  if (props.total > 0) {
    return (
      <Datagrid {...dataGridProps}>
        <TextField
          source="phoneNumber"
          label="Phone Number"
          sortable={false}
          id="phone-number"
        />
        <TextField
          source="phoneType"
          label="Phone Type"
          sortable={false}
          id="phone-type"
        />
        {hasEditPermission && (
          <EditButtonWithOnClick
            label=""
            className={classes.editButton}
            headerClassName={classes.editButtonColumnStyle}
            onClick={handlePhoneEditButtonClick}
          />
        )}
      </Datagrid>
    );
  } else if (props.loading) {
    return <Loading />;
  } else {
    return 'There are no phone numbers to be displayed';
  }
};

export default withStyles(styles)(UserPhoneDatagrid);
